// Base path for all Academy routes. Cut over from the VPN-only '/academy-preview'
// preview path to the public '/academy' once content was complete in production.
export const ACADEMY_BASE_PATH = '/academy'
